import type { ProductNodeBuilderProps } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/block/DefaultBlock';
import { connect } from 'react-redux';
import { commonFormActions } from 'state/forms/actions/form';
import type { ProductNode } from 'state/product-description/model';
import {
  getDynamicFormInfos,
  getSpmHiddenTabs,
  getSpmVisibleTabs,
  getStaticFormInfos,
  isStaticTab,
} from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { BatchWorkspaceVersion, QuoteWorkspaceVersion } from 'state/userPreferences/userPreferences.model';

interface OwnProps {
  tabId: string;

  node: ProductNode;
  quoteWorkspaceVersion: QuoteWorkspaceVersion;
  batchWorkspaceVersion: BatchWorkspaceVersion;
  mustForceAdvancedMode: boolean;
}

interface StateProps {
  activeTab?: string;

  hiddenTabsId: string[] | undefined;

  visibleTabsId: string[] | undefined;
  workspaceType: 'static' | 'dynamic';
}

interface DispatchProps {
  setActiveFormTab(tabId: string, activeTabId: string, workspaceType: 'static' | 'dynamic'): void;
}

export type TabsBlockProps = StateProps & OwnProps & DispatchProps & ProductNodeBuilderProps;

export const mapStateToProps = (state: AppState, { tabId }: OwnProps): StateProps => {
  const isStatic = isStaticTab(state, tabId);
  const hiddenTabsId = isStatic === true ? getSpmHiddenTabs(state) : undefined;
  const visibleTabsId = isStatic === true ? getSpmVisibleTabs(state) : undefined;
  const activeTab =
    isStatic === true
      ? getStaticFormInfos(state, tabId)?.formActiveTab
      : getDynamicFormInfos(state, tabId)?.formActiveTab;

  return {
    activeTab,
    workspaceType: isStatic === true ? 'static' : 'dynamic',
    hiddenTabsId,
    visibleTabsId,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch): DispatchProps => ({
  setActiveFormTab(tabId: string, activeTabId: string, workspaceType: 'static' | 'dynamic') {
    dispatch(commonFormActions.quoteActiveFormTabChanged(workspaceType, tabId, activeTabId));
  },
});

export const connectTabsBlock = connect(mapStateToProps, mapDispatchToProps);
